import { curryN } from "ramda";
export default curryN(2, (f, xs) => xs.flatMap(f));
//# sourceMappingURL=flatMap.mjs.map